import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import "react-leaflet-fullscreen/styles.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// import Pusher from "pusher-js";

// new Pusher(import.meta.env.VITE_API_PUSHER_KEY, {
//   cluster: "ap1",
// });

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
